import { http } from '@packet/management/src/api/http';
import type { GetDashboardResponse } from '../../DTO/dashboard';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取仪表盘数据
 */
export const getDashboard = async (): Promise<ApiResponse<GetDashboardResponse>> => {
  return http().get('/api/v1/dashboard');
};
